interface CartDeliveryAddress {
  __typename?: "CartDeliveryAddress";
  firstName?: string | null;
  lastName?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  company?: string | null;
  countryCode?: string | null;
  provinceCode?: string | null;
  phone?: string | null;
  zip?: string | null
}

export function findAddressInCart(
  address: CartDeliveryAddress,
  cartAddresses: Array<{
    __typename?: "CartSelectableAddress";
    selected: boolean;
    address: CartDeliveryAddress
    id: string,
  }>
): {address: CartDeliveryAddress, id: string} | null {

  const existingAddress = cartAddresses.find(cartAddress => {
    const addressMatches =
      normalizeString(cartAddress.address.address1) === normalizeString(address.address1) &&
      normalizeString(cartAddress.address.address2 || '') === normalizeString(address.address2 || '') &&
      normalizeString(cartAddress.address.city) === normalizeString(address.city) &&
      normalizeString(cartAddress.address.provinceCode) === normalizeString(address.provinceCode) &&
      normalizeString(cartAddress.address.zip) === normalizeString(address.zip) &&
      normalizeString(cartAddress.address.firstName) === normalizeString(address.firstName) &&
      normalizeString(cartAddress.address.lastName) === normalizeString(address.lastName);
    return addressMatches;
  });

  if (!existingAddress?.id || !existingAddress?.address) {
    return null;
  }

  return {id: existingAddress?.id, address: existingAddress?.address };
}

function normalizeString(str: string | null | undefined): string {
  if (str === null || str === undefined) {
    return '';
  }
  return str.trim().toLowerCase();
}
